import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n/index.js';

import './ErrorPage.scss';

export const ErrorPage = () => (
  <main className="page site of-public-page" data-page-id="error">
    <section
      className={`of-error-page__content ${dsClass.DISPLAY_FLEX} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.ALIGN_ITEMS_CENTER} ${dsClass.JUSTIFY_CONTENT_CENTER} ${dsClass.PADDING_TOP_8} ${dsClass.PADDING_BOTTOM_8} ${dsClass.PADDING_HORIZONTAL_3}`}
    >
      <div className={`of-error-page__message ${dsClass.DISPLAY_FLEX}`}>
        <h2 className={`${dsClass.H2} ${dsClass.MARGIN_0}`}>{t.RKZC('An error occurred in the service')}</h2>
        <div className={dsClass.FONT_SIZE_LARGE}>
          <p className={dsClass.MARGIN_0}>{t.Y3R5('Unfortunately, we could not process your request.')}</p>
          <p className={dsClass.MARGIN_0}>{t.JZHE('Please clear browser cookies, cache and try again.')}</p>
          <p className={dsClass.MARGIN_0}>
            {t.QJEF('If the problem continues, please contact our business customer support.')}
          </p>
        </div>
      </div>
      <CL.Link
        buttonColor="light"
        buttonSize="m"
        className={dsClass.BACKGROUND_COLOR_WHITE}
        linkHref={paths.CONTACT_INFO}
        linkStyle="link-button"
      >
        {t.R5U2('Contact customer support')}
      </CL.Link>
    </section>
  </main>
);
